import React from 'react';
import { Check } from 'lucide-react';

const Step3 = ({ data, onSelect, overrides }) => {
  const benefits = [
    'Supports healthy thyroid hormone production',
    'Helps improve energy and metabolic function',
    'Supports hair, skin, and temperature regulation'
  ];

  return (
    <div className="flex flex-col">
      {/* Heading */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-1" style={{ color: '#1a1a2e' }}>
        Meet <span className="gradient-text">Hashi-aid</span>.
      </h1>
      <h2 className="font-serif text-3xl md:text-4xl leading-tight mb-8" style={{ color: '#1a1a2e' }}>
        The thyroid support formula{' '}
        <span className="underline-highlight">designed to help restore balance.</span>
      </h2>

      {/* Product Card */}
      <div className="product-card p-6 mb-6">
        {/* Product Image */}
        <div className="flex justify-center mb-6">
          <div className="relative w-48 h-56 flex items-center justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_quiz-journey-8/artifacts/v2lfdhha_Hashi-aid_FRONT.png"
              alt="Hashi-aid Thyroid Support"
              className="max-h-full max-w-full object-contain drop-shadow-lg"
              style={{
                filter: 'drop-shadow(0 10px 30px rgba(120, 116, 248, 0.2))'
              }}
            />
          </div>
        </div>

        {/* Benefits list */}
        <div className="flex flex-col gap-3">
          {benefits.map((benefit, index) => (
            <div key={index} className="check-item">
              <div 
                className="w-5 h-5 rounded-full border flex items-center justify-center flex-shrink-0"
                style={{ borderColor: '#09C9E9' }}
              >
                <Check className="w-3 h-3" style={{ color: '#09C9E9' }} strokeWidth={2.5} />
              </div>
              <span className="text-sm" style={{ color: '#333' }}>{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Step3;
